import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "page",
  style: {"padding-bottom":"12px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, { title: "说明视频" }),
    _cache[0] || (_cache[0] = _createElementVNode("p", null, "智能床", -1)),
    _createVNode(_component_van_list, { class: "card" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bedList, (item) => {
          return (_openBlock(), _createBlock(_component_van_cell, {
            key: item.key,
            title: item.name,
            onClick: ($event: any) => (_ctx.$router.push(`/instructionalVideo/${item.key}`))
          }, null, 8, ["title", "onClick"]))
        }), 128))
      ]),
      _: 1
    }),
    _cache[1] || (_cache[1] = _createElementVNode("p", null, "太空椅", -1)),
    _createVNode(_component_van_list, { class: "card" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chairList, (item) => {
          return (_openBlock(), _createBlock(_component_van_cell, {
            key: item.key,
            title: item.name,
            onClick: ($event: any) => (_ctx.$router.push(`/instructionalVideo/${item.key}`))
          }, null, 8, ["title", "onClick"]))
        }), 128))
      ]),
      _: 1
    }),
    _cache[2] || (_cache[2] = _createElementVNode("p", null, "其他", -1)),
    _createVNode(_component_van_list, { class: "card" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherList, (item) => {
          return (_openBlock(), _createBlock(_component_van_cell, {
            key: item.key,
            title: item.name,
            onClick: ($event: any) => (_ctx.$router.push(`/instructionalVideo/${item.key}`))
          }, null, 8, ["title", "onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}